const colors = {
	primary: {
		ice: '#FFFFFF',
		ocean: '#005EDC',
		oceanLight: '#CCDFF8',
	},
	secondary: {
		polar: '#E1ECFA',
		polarLight: '#EDF4FC',
		deepCove: '#061556',
		deepCoveLight: '#384378',
		deepCoveVeryLight: '#9BA1BB',
		pantone: '#D4FAEA',
		magentaDeep: '#BD10E0',
		magentaDark: '#810B99',
		gold: '#CA9600',
		goldBold: '#664C00',
	},
	tertiary: {
		sky: 'linear-gradient(120.33deg, #0366EC 11.58%, #00DCDC 86.59%)',
	},
	functional: {
		lightestGrey: '#D8D8D8',
		black: '#000000',
		lighterGrey: '#C4C4C4',
		darkGrey: '#4A4A4A',
		borderGrey: '#A3AACC',
		grey: '#787A7E',
		lightDarkGrey: '#979797',
		paleGrey: '#EDEEF3',
		offWhite: '#F8F8F8',
		lightGrey: '#EBEDF0',
		middleGray: '#cdcfd1',
		sun: '#FEBD11',
		darkSun: '#E5A600',
		pink: '#BD10E0',
		blue: '#203559',
		darkBlue: '#243556',
		red: '#EB5757',
		softGrey: '#494A4C',
		blueButton: '#0246E3',
		blueRaiting: '#2D8AC6',
		green: '#00A767',
		placeholder: '#7882B2',
		inputBorderColor: '#A3AACC',
		errorRed: '#ED1D24',
		darkestGrey: '#181819',
		weakGrey: '#828282',
		loadingGrey: '#e5e5e5',
		gold: '#FDBB11',
		darkGold: '#A87E10',
		seaweed: '#07828D',
		ateneo: '#004275',
		soldOut: '#F00',
		promoCardBorder: '#d2d6e8',
	},
	celebrity: {
		grey: '#333333',
		blue: '#002859',
		soldOut: '#C00',
		lightOrange: '#E87435',
		darkOrange: '#D16930',
		lightBlue: '#366EB2',
		dropDownLabel: '#1C4B88',
		dropDownBackground: '#E6EAF1',
		promoCardBlue: '#13818D',
		promoCardBorder: '#D8DBEC',
		promoCardBackground: '#EBEDF5',
		promoCardPerks: '#4D698B',
		riverBadge: '#299BE1',
	},
	rccl: {
		labelNog: '#1D2340',
		lavelResultsHeader: '#535455',
		dropDownBackground: '#E5E7F0',
		dropDownLabel: '#2C3E8B',
		dropDownBackgroundHover: '#BDC2DB',
	},
};

export default colors;
